import * as angular from 'angular';
import {IController, IScope} from "angular";
import * as _ from "lodash";

export class DeliveriesTableItemCtrl implements IController {
  id: any;
  isSelected: any;
  isExpended: any;
  columns: any;
  toggle: any;
  onExpand: Function;

  private service: any;

  /* @ngInject */
  constructor(private $delivery, private $mdMedia, private $scope: IScope) {
  }

  $onInit() {
    if (this.id) {
      this.$delivery(this.id).$bindCtrlToId(this.$scope, this, 'service', 'id');
    }
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.$onInit();
    }
  };


  checkBoxClick() {
    this.toggle({serviceId: this.id});
  }

  onBeforeExpand() {
    const hasRelations = _.some(this.service.taskList, (t) => {
      return t.relations && t.relations.length;
    });
    if (hasRelations) {
      this.onExpand({serviceId: this.id});
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesTableItem', {
    bindings: {
      id: '<',
      isSelected: '<',
      isExpended: '<',
      columns: '<',
      toggle: '&',
      onExpand: '&'
    },
    template: require('./deliveries-table-item.html').default,
    controller: DeliveriesTableItemCtrl
  });
